<main class="auth-page auth-flow-page min-vh-100 position-relative overflow-hidden bg-white text-dark">
  <div class="container position-relative min-vh-100 d-flex flex-column px-3 py-3 py-lg-4">
    <section class="flex-grow-1 d-flex align-items-center py-3">
      <div class="row align-items-center justify-content-center g-5 w-100 mx-0">
        <aside class="col-lg-5 d-none d-lg-flex flex-column align-items-center justify-content-center text-center">
          <div class="aic-hero-orb-wrap position-relative mt-0 mb-4">
            <div class="aic-hero-ring aic-hero-ring-outer position-absolute rounded-circle pe-none" aria-hidden="true"></div>
            <div class="aic-hero-ring aic-hero-ring-mid position-absolute rounded-circle pe-none" aria-hidden="true"></div>
            <router-link
              to="/"
              class="aic-hero-orb position-absolute rounded-circle d-flex align-items-center justify-content-center"
              aria-label="AI Campus Data Intelligence home"
            >
              <span class="aic-hero-orb-mark d-block"></span>
            </router-link>
          </div>
          <p class="text-secondary small fw-semibold text-uppercase mt-3 mb-2">Account restored</p>
          <h1 class="fs-3 fw-bold text-dark mb-3">You are cleared to reconnect.</h1>
          <p class="text-secondary small mb-0">
            Your new password is ready for the AI Campus workspace.
          </p>
        </aside>

        <section class="auth-panel col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4 card border border-dark bg-white shadow-lg rounded-4 p-4 text-dark text-center mx-auto">
          <div class="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 p-3 border border-danger bg-danger-subtle text-danger shadow-sm">
            <i class="bi bi-check-lg fs-4"></i>
          </div>

          <p class="text-secondary small fw-semibold text-uppercase mb-2">Account restored</p>
          <h1 class="fs-3 fw-bold text-dark mb-2">Password reset complete</h1>
          <p class="text-secondary small mb-4">
            Your password has been reset successfully. Sign in using your new credentials.
          </p>

          <SnackbarMessage
            :success-message="success_message"
            @dismiss-success="success_message = ''"
          />

          <router-link to="/login" class="btn btn-danger btn-sm rounded-pill fw-semibold w-100 px-3 py-2 shadow-sm">
            Return to sign in
          </router-link>
        </section>
      </div>
    </section>
  </div>
</main>
